var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 9.66634C0.845833 9.66634 0.571278 9.5522 0.343 9.32393C0.114333 9.09526 0 8.82051 0 8.49967V6.74967H1.16667V8.49967H8.16667V6.74967H9.33333V8.49967C9.33333 8.82051 9.2192 9.09526 8.99092 9.32393C8.76225 9.5522 8.4875 9.66634 8.16667 9.66634H1.16667ZM4.66667 7.33301L1.75 4.41634L2.56667 3.57051L4.08333 5.08717V0.333008H5.25V5.08717L6.76667 3.57051L7.58333 4.41634L4.66667 7.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.015dd6a2c4043680d9a91fa20914facd.svg";
export { ForwardRef as ReactComponent };